module.exports = __webpack_public_path__ + "static/media/alexa-badge.2fbc2dda.png";